import { Globe } from "lucide-react";
import { useT } from "@/context/I18nContext";

export default function LanguageSelector() {
  const { lang, setLang } = useT();
  return (
    <div className="flex items-center gap-1 text-xs" data-testid="lang-selector">
      <Globe size={12} className="text-[#A39E93]" />
      <button
        onClick={() => setLang("it")}
        className={`px-1.5 py-0.5 rounded ${lang === "it" ? "text-[#E5A93C] font-bold" : "text-[#A39E93] hover:text-[#F7F4EE]"}`}
        data-testid="lang-it"
      >
        IT
      </button>
      <span className="text-[#A39E93]/50">/</span>
      <button
        onClick={() => setLang("en")}
        className={`px-1.5 py-0.5 rounded ${lang === "en" ? "text-[#E5A93C] font-bold" : "text-[#A39E93] hover:text-[#F7F4EE]"}`}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
}
